import axios from 'axios'
import type { App } from 'vue'
import { attachAuthInterceptors } from '@/utils/auth-interceptors'

const apiProphet = axios.create({
  baseURL: import.meta.env.VITE_PROPHET_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

attachAuthInterceptors(apiProphet)

export default {
  install(app: App) {
    app.config.globalProperties.$apiProphet = apiProphet
  },
}

export { apiProphet }
